<div class="container-fluid p-0 min-vh-100">
  <router-outlet></router-outlet>
  <ui-fh-side-bar [id]="'user-control-panel'" [sidebarPosition]="'RIGHT'" [route]="'user-data'" [initialRoute]="'menu'" [headless]="true">
    <ui-fh-side-bar-header [id]="'user-control-panel'"></ui-fh-side-bar-header>
    <router-outlet name="user-data"></router-outlet>
  </ui-fh-side-bar>
  <ui-fh-loading [fullscreen]="true" *ngIf="loading"></ui-fh-loading>
  <ui-fh-toaster-messages></ui-fh-toaster-messages>
</div>
